import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../server/validationMethods.js';
import {personModal,personType}from '../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import {BASE_URL} from "../../server/constants"
import {get} from "../../server/actionsParent.js"
class W_FirstParentInfo extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading:false,
            draftData:{}
           
        }
    }
    componentDidMount=()=>{
        //this.getSaveData()
    }

    buildStudentsList=()=>{
        let _lunchBreakfastObj=this.props.lunchObj;
        _lunchBreakfastObj.mealSchoolId=this.props.schoolInfo.id;
        _lunchBreakfastObj.studentList=[]
        _lunchBreakfastObj.childList=_lunchBreakfastObj.childList || [];
        _lunchBreakfastObj.adultList=_lunchBreakfastObj.adultList || []; 
        if(this.props.schoolInfo.id===0){
          _lunchBreakfastObj.studentList=[];
        }else{
            this.props.setLoader(true);

          let url=BASE_URL+"/website/studentsInfo?mealSchoolId="+this.props.schoolInfo.id+"&parentEmail="+_lunchBreakfastObj.persons[0].contact.email+"&schoolYear="+this.props.schoolInfo.sessionYear
          if(this.props.schoolInfo.districtStatus){
            url=`${BASE_URL}/website/studentsInfoByDistrict/${this.props.schoolInfo.id}?parentEmail=${_lunchBreakfastObj.persons[0].contact.email}`;
          }
        fetch(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
          let _studentsList=[]
          console.log("Student Info Data:::::::",data);
            data.map((student,k)=>{
                let _personModal=JSON.parse(JSON.stringify(personModal));
                _personModal.personType=personType.student;
                _personModal.fname= student.firstName;
                _personModal.lname= student.lastName;
                _personModal.mname= "";
                _personModal.income=[
                    //Object.assign({},incomeModal)
                ]
                _personModal.grade= student.gradeName;
                _personModal.studentRecId=student.studentRecId;
                _personModal.id=k;
                //_personModal.mealSchoolId=student.schoolInfo.id;
                _personModal.mealSchoolId=student.mealSchoolId;
                // _personModal.schoolYear=student.schoolYear;
                let index = this.props.lunchObj.householdAppInfo.findIndex(record => record.studentRecId && record.studentRecId.toString() === student.studentRecId || (record.mealSchoolId && record.fname == student.firstName && record.lname == student.lastName));
                //console.log("Index::::::",index);
                if (index !== -1) {
                    _personModal.isSelected=true;
                    _personModal.ethenticity=this.props.lunchObj.householdAppInfo[index]['ethenticity'];
                    _personModal.race=this.props.lunchObj.householdAppInfo[index]['race'];
                    _personModal.liveUnderFosterCare=this.props.lunchObj.householdAppInfo[index]['liveUnderFosterCare'];
                    _personModal.mcKinneyVentoHomeless=this.props.lunchObj.householdAppInfo[index]['mcKinneyVentoHomeless'];
                    _personModal.migrantEducationPrg=this.props.lunchObj.householdAppInfo[index]['migrantEducationPrg'];
                    _personModal.runaway=this.props.lunchObj.householdAppInfo[index]['runaway'];
                    _personModal.headStart=this.props.lunchObj.householdAppInfo[index]['headStart'];
                    _personModal.homelessOrMigrantOrRunaway=this.props.lunchObj.householdAppInfo[index]['homelessOrMigrantOrRunaway'];
                    _personModal.income=this.props.lunchObj.householdAppInfo[index]['income'];
                }else{
                    _personModal.isSelected=false;
                }
                _studentsList.push(_personModal)
        });
        _lunchBreakfastObj.studentList=_studentsList;
        console.log("Student Info IN StudentList:::::::",_studentsList);
        console.log("_lunchBreakfastObj:::::::",_lunchBreakfastObj);
    
        console.log("_lunchBreakfastObj111:::::::",_lunchBreakfastObj);
        this.props.onSubmitParentForm(_lunchBreakfastObj,()=>{
            this.props.jumpToStep(3);
        });
        this.props.setLoader(false);
        }).catch(
                (error) => {
                    //_addNotificationError('Activation failed. Please try again later', this);
                    console.log('already applied students', error);
                    _lunchBreakfastObj.studentList=[]
                    this.props.onSubmitParentForm(_lunchBreakfastObj,()=>{
                        this.props.jumpToStep(3);
                    })
                    this.props.setLoader(false);
                }
            );
        }  
      }

      getSaveData=(type)=>{
        console.log("Props lunchObj::::",this.props.lunchObj);
        let _lunchBreakfastObj=this.props.lunchObj;
        this.setState({ loading: true });
       // const suchoolYearValue = this.state.schoolObject.sessionYear.schoolYearValue
        get('/getHouseholdAppById?parentEmail=' + _lunchBreakfastObj.persons[0].contact.email,false,true)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log("Draft Data:::::::::::",data);
            data["persons"] = data["householdAppInfo"].filter(item => (item.personType === "Adult" && item.contact !== null));
            data["childList"] = data["householdAppInfo"].filter(item => item.personType === "Child" && item.mealSchoolId == null);
            data["adultList"] = data["householdAppInfo"].filter(item => item.personType === "Adult" && item.contact === null);
            console.log("this.props.lunchobj::::::",this.props.lunchObj);
            data['assistancePrograms'] = data['persons'][0]['assistancePrograms'] || this.props.lunchObj.assistancePrograms;
            data['isIncomeAfter'] = data['incomeAfter'];
            data['isAllFoster'] = data['allFoster'];
           // data['mealSchoolId'] = this.props.schoolInfo.id;
            console.log("Data::::",data);
            this.props.updateLunchObj(data);
            console.log("Props:::::",this.props.lunchObj);
            this.setState({draftData:data, loading: false });
        }).catch(
                (error) => {
                    this.setState({ loading: false });
                    if(this.props.lunchObj.hasOwnProperty('applicationId')){
                        delete this.props.lunchObj['applicationId'];
                    }
                    console.log("No response from get:::::::",this.props.lunchObj);
                    this.props.lunchObj.householdAppInfo = this.props.lunchObj.persons;
                    
                    this.props.updateLunchObj(this.props.lunchObj);
                    console.log('Get School data response', error)
                }
            );
        }

render(){
    const {lunchObj}=this.props
    const { t, i18n } = this.props;
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <h3 className="color-1"><Trans>I certify (promise)</Trans>...</h3>
                        <p><Trans>that all information on this application is true and that all income is reported</Trans>.</p>
                        <p> <Trans>I understand that this information is given in connection with the receipt of federal funds, and that school officials may verify (check) the information</Trans>. <Trans>I am aware that if I purposely give false information, my children may lose meal benefits, and I may be prosecuted under applicable state and federal laws</Trans>.</p>
                        <p><strong><Trans>Enter the name of the adult household member completing the application</Trans>.</strong></p>
                    </div>
                </div>
            </div>
            <Form ref={f=>this.frmPrimAdultInfo=f}>
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-md-3">
                            <label><Trans>First Name</Trans> *</label>
                            <Input type="text" name="fname" className="form-control" placeholder={t('First')}
                                value={lunchObj.persons[0].fname} 
                                validations={[required]} requiredmsg={t('Please provide parent first name')} onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}
                            />
                        </div> 
                        <div className="col-md-2">
                            <label><Trans>Middle Name</Trans></label>
                            <Input type="text" name="mname" className="form-control" placeholder={t('Middle')}
                            value={lunchObj.persons[0].mname} 
                            onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}/>
                        </div> 
                        <div className="col-md-3">
                            <label><Trans>Last Name</Trans> *</label>
                            <Input type="text" name="lname" className="form-control" placeholder={t('Last')}
                            value={lunchObj.persons[0].lname} 
                            validations={[required]} requiredmsg={t('Please provide parent last name')} 
                            onChange={(e)=>{
                                    this.props.onApplicantFieldChange(e.target.name,e.target.value);
                                }}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{paddingTop:'12px'}}>
            <div className="col-md-3 form-group">            
        <label><Trans>E-Mail</Trans> </label>
                <input type="text" name="email" className="form-control" placeholder={t('EMail')}
                    value={lunchObj.persons[0].contact.email} onChange={(e)=>{
                        let _contact=lunchObj.persons[0].contact;
                        _contact.email=e.target.value;
                                    this.props.onApplicantFieldChange('contact',_contact);
                                    //this.getSaveData();
                                }}
                                onBlur={(e)=>{
                                    this.getSaveData();
                                }}
                />
            </div>
            </div>
            </Form>
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(1)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        this.frmPrimAdultInfo.validateAll();
                            if(!isValidForm(this.frmPrimAdultInfo)){
                                return false;
                            }else{
                                this.buildStudentsList();
                            }
                    }}><Trans>Continue</Trans>
                    </button>
                </div>
            </div>
        </div>
    )
}
}
export default translate("translations")(W_FirstParentInfo);


// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/w_firstParentInfo.jsx